import type { MappedIconMicro } from "@/icons/icon-mapping-micro";

type ResponsiveDevice = {
  key: string;
  icon: MappedIconMicro;
  name: string;
  width: number;
  height: number;
};

export type ResponsiveSize = {
  key?: string;
  width: number;
  height: number;
};

export const RESPONSIVE_DEVICES: ResponsiveDevice[] = [
  {
    key: "desktop",
    name: "Desktop",
    icon: "computer-desktop",
    width: 1920,
    height: 1080,
  },

  {
    key: "iphone_se",
    name: "iPhone SE",
    icon: "device-phone-mobile",
    width: 375,
    height: 667,
  },
  {
    key: "iphone_xr",
    name: "iPhone XR",
    icon: "device-phone-mobile",
    width: 414,
    height: 896,
  },

  {
    key: "galaxy_s8plus",
    name: "Galaxy S8+",
    icon: "device-phone-mobile",
    width: 360,
    height: 740,
  },
  {
    key: "pixel_7",
    name: "Pixel 7",
    icon: "device-phone-mobile",
    width: 412,
    height: 915,
  },

  {
    key: "ipad_mini",
    name: "iPad Mini",
    icon: "device-tablet",
    width: 768,
    height: 1024,
  },
  {
    key: "ipad_pro",
    name: "iPad Pro",
    icon: "device-tablet",
    width: 1024,
    height: 1366,
  },
];
